import React, { Component } from "react";
import { SelectControl  } from '@wordpress/components';


class SourceProduct extends Component {

    constructor(props) {
        super(props);
    }



    render() {

        const { attributes: {sourceProduct}, setAttributes } = this.props;

        const changeFunction = (value) => {
            setAttributes({
                sourceProduct: value
            });
        }

        return (
            <div className="components-base-control">
                <div className="components-base-control__field">
                    <label className="components-base-control__label">Source</label>
                    <SelectControl
                        checked={ sourceProduct }
                        onChange={ changeFunction }
                        options={ [
                            { value: 'twitter', label: 'Twitter' },
                            { value: 'facebook', label: 'Facebook' },
                        ] }
                    />
                </div>
            </div>
        );

    }
}


export default SourceProduct;